// Owner: S6, admin-ops (§9.19). Every import of the workspace (an admin) or of the member; reached from an
// object's import menu, the first-run checklist and ⌘K.
import { createFileRoute } from '@tanstack/react-router';
import { ImportHistoryPage } from '../../features/import/ImportHistoryPage';

export const Route = createFileRoute('/_app/imports')({ component: ImportHistoryPage });
